import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../../home-page/HomePage.module.scss';
import { commonActions, ratesActions, transcationActions } from '../../../stores/_actions';
import kuwaitRoundFlag from 'assets/images/kuwait-flag-round.jpg';
import Label from '../../../constants/Label';
import Validator from '../common-functions';

function Transfer() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const [lastChange, setLastChange] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(commonActions.currency());
    setRCFlagImg((currencyR) => (currencyR = location.state?.items?.CurrencyFlagPath));
    setRCFlag((rcFlag) => (rcFlag = location.state?.items?.CurrencyCode));
    dispatch(transcationActions.setTransactionReceiveCur(location.state?.items?.CurrencyCode));
    dispatch(transcationActions.clearTransInfo());
    return () => {
      setSendAmount('');
    };
  }, []);

  const location = useLocation();

  const [beneficiary, setStyle] = useState(false);
  const [LCAmount, lcAmount] = useState(false);
  const [RCAmount, rcAmount] = useState(false);
  const [inc, setInc] = useState('Select Beneficiary');
  const [rcFlag, setRCFlag] = useState('');
  const [currencyR, setRCFlagImg] = useState('');
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
      ServNo: '',
      AmountType: '',
      Amount: '',
      RcvCurrency: '',
    },
  });
  const [transferButton, setTransferButton] = useState(true);
  const [beneCheck, setbeneCheck] = useState(true);
  const [receiveAmount, setReceiveAmount] = useState('');
  const [receiveAmountErr, setReceiveAmountErr] = useState('');
  const [sendAmount, setSendAmount] = useState('');
  const [sendAmountErr, setSendAmountErr] = useState('');
  const [focusSet, setFocus] = useState(false);
  const style = location.pathname == '/home' || location.pathname == '/transfer' ? styles.width49 : styles.width100;
  const widthStyle =
    location.pathname == '/transfer' || location.pathname == '/rates' || location.pathname == '/transcation' || location.pathname == '/branchies'
      ? styles.width100
      : styles.width48;
  const flexStyle = location.pathname == '/transfer' || location.pathname == '/rates' || location.pathname == '/transcation' ? '' : styles.flexStyle;
  const currency = useSelector((state) => state.currency.data);
  // const beneficiaryList = useSelector((state) => state.beneficairy);

  const selectBeneficiaryName = (event, items) => {
    setStyle(!beneficiary);
    setInc((inc) => (inc = { items: items }));
    setRCFlag((rcFlag) => (rcFlag = items.CurrencyCode));
    setRCFlagImg((currencyR) => (currencyR = items.CurrencyFlagPath));
    setPayload((payload) => ({
      ...payload,
      Data: {
        CustomerCode: items.CustomerCode,
        ServNo: items.ServNO,
        AmountType: '',
        Amount: '',
        RcvCurrency: '',
      },
    }));
    setTransferButton(false);
    setbeneCheck(beneCheck);
    dispatch(transcationActions.setTransactionReceiveCur(items.CurrencyCode));
  };

  const recieveRCFlag = (event, items) => {
    rcAmount(!RCAmount);
    setRCFlag((rcFlag) => (rcFlag = items.ID));
    setRCFlagImg((currencyR) => (currencyR = items.CurrencyFlagPath));
  };

  let beneficiaryList;
  useSelector((state) => {
    beneficiaryList = state.beneficary?.data;
    setTimeout(() => {}, 10);
  });

  const customerList =
    beneficiaryList &&
    beneficiaryList.map((items, index) => (
      <a key={index} id={items.BenfName} data={JSON.stringify(items)} onClick={(e) => selectBeneficiaryName(this, items)}>
        {items.BenfName}
      </a>
    ));

  const RCFlaglist =
    currency &&
    currency.map((items) => (
      <a key={items.ID} id={items.ID} data={JSON.stringify(items)} onClick={(e) => recieveRCFlag(this, items)}>
        <img src={items.CurrencyFlagPath} /> {items.ID}
      </a>
    ));

  const AmountCalculateLC = (amount) => {
    if (inc == 'Select Beneficiary' && location.pathname !== '/transfer') {
      setbeneCheck(false);
      setSendAmount('');
      return;
    }
    setFocus(true);
    setSendAmountErr('');
    setLastChange('Send');
    const checkNumber = Validator.currencyValidate(amount.value);
    if (checkNumber && amount.value) {
      const numAfterDeciml = String(amount.value).split('.');
      if (numAfterDeciml[1]) {
        if (Number(numAfterDeciml[1].length) > 3) {
          setSendAmountErr('Value after decimal cannot exceed 3 digits!');
          return;
        }
      }
    } else if (!checkNumber && amount.value) {
      setSendAmountErr('Amount is required & can be digits only!');
      return;
    }
    // setSendAmount(payload.prevSendAmt);
    setSendAmount(amount.value);
    payload.prevSendAmt = amount.value;
    delete payload.prevRCAmt;
    payload.Data['Amount'] = amount.value;
    payload.Data['RcvCurrency'] = profile?.CurrencyCode1;
    payload.Data['AmountType'] = 'L';
    if (location.pathname == '/transfer') {
      payload.Data['ServNo'] = location.state.items.ServNO;
    }
    setPayload((payload) => ({ ...payload }));
    dispatch(ratesActions.rateCharges(payload));
  };

  const AmountCalculateRC = (amount) => {
    setErrorMsg(false);
    if (inc == 'Select Beneficiary' && location.pathname !== '/transfer') {
      setbeneCheck(false);
      setReceiveAmount('');
      return;
    }
    setFocus(false);
    setReceiveAmountErr('');
    setLastChange('Receive');
    const checkNumber = Validator.currencyValidate(amount.value);
    if (checkNumber && amount.value) {
      const numAfterDeciml = String(amount.value).split('.');
      if (numAfterDeciml[1]) {
        if (Number(numAfterDeciml[1].length) > 3) {
          setReceiveAmountErr('Value after decimal cannot exceed 3 digits!');
          return;
        }
      }
    } else if (!checkNumber && amount.value) {
      setReceiveAmountErr('Amount is required & can be digits only!');
      return;
    }
    setReceiveAmount(amount.value);
    payload.prevRCAmt = amount.value;
    delete payload.prevSendAmt;
    payload.Data['Amount'] = amount.value;
    payload.Data['RcvCurrency'] = profile?.CurrencyCode1; // rcFlag;
    payload.Data['AmountType'] = 'F';
    if (location.pathname == '/transfer') {
      payload.Data['ServNo'] = location.state.items.ServNO;
    }
    setPayload((payload) => ({ ...payload }));
    dispatch(ratesActions.rateCharges(payload));
  };

  const [errorMsg, setErrorMsg] = useState(false);
  const transButton = () => {
    setLastChange(null);
    if (sendAmount !== undefined && sendAmount !== 0 && !sendAmount) {
      setSendAmountErr('Please enter the amount');
      return;
    } else if (sendAmount == 0) {
      setSendAmountErr('Amount should be greater than 0');
      return;
    } else {
      setSendAmountErr('');
    }
    if (sendAmount == 0 || receiveAmount == 0) {
      setReceiveAmountErr('Amount should be greater than 0');
      return;
    }
    const menu = {
      beneficiary: false,
      amount: true,
      payment: false,
      confirm: false,
      transfer: false,
      print: false,
    };
    setErrorMsg((errorMsg) => (!receiveAmount ? true : false));
    if (location.pathname == '/transfer') {
      history.push({ pathname: '/transfer', state: { ...location.state, rateOfTransfer, menu } });
    } else {
      if (inc == 'Select Beneficiary' && inc.items == null) {
        setbeneCheck(!beneCheck);
        return;
      } else {
        history.push({ pathname: '/transfer', state: { ...inc, rateOfTransfer, menu } });
      }
    }
  };

  let rateOfTransfer;
  useSelector((state) => {
    rateOfTransfer = state.rateCharges;
    setTimeout(() => {
      // focusSet
      //   ? setReceiveAmount((receiveAmount) => (receiveAmount = rateOfTransfer.data?.sFcyAmount))
      //   : setSendAmount((sendAmount) => (sendAmount = rateOfTransfer.data?.sLcyAmount));
      // setReceiveAmount((receiveAmount) => (receiveAmount = rateOfTransfer.data?.sFcyAmount));
      if (lastChange === 'Receive') {
        setSendAmount((sendAmount) => (sendAmount = rateOfTransfer.data?.sLcyAmount));
      } else if (lastChange === 'Send') {
        setReceiveAmount((receiveAmount) => (receiveAmount = rateOfTransfer.data?.sFcyAmount));
      } else {
        setSendAmount((sendAmount) => (sendAmount = rateOfTransfer.data?.sLcyAmount));
        setReceiveAmount((receiveAmount) => (receiveAmount = rateOfTransfer.data?.sFcyAmount));
      }
    }, 100);
  }, []);

  const searchText = (e) => {
    e.preventDefault();
    let txtValue;
    const input = document.getElementById(`mySearch`);
    const filter = input.value.toUpperCase();
    const ul = document.getElementById(e.target.name);
    const a = ul.getElementsByTagName('a');
    for (let i = 0; i < a.length; i++) {
      txtValue = a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = '';
      } else {
        a[i].style.display = 'none';
      }
    }
  };

  const handleChange = (e) => {};
  let sendAmt = lastChange === 'Receive' && receiveAmount === '' ? '' : sendAmount;
  if (payload.prevRCAmt === '' && !payload.prevSendAmt) {
    sendAmt = '';
  }
  let rcAmt = lastChange === 'Send' && sendAmount === '' ? '' : receiveAmount;
  if (payload.prevSendAmt === '' && !payload.prevRCAmt) {
    rcAmt = '';
  }
  return (
    <div className={styles.pageLeft__transfer + ` ` + style}>
      <h2 style={{ margin: '0px 0px 16px 6px' }}> {Label.Transfer.heading}</h2>
      {location.pathname == '/transfer' ? (
        ''
      ) : (
        <div className={styles.formGroup} style={{ margin: '0px 5px 8px 5px' }}>
          <label>Beneficiary</label>
          <div className={styles.dropdown}>
            <button type="button" onClick={() => setStyle(!beneficiary)} onChange={(e) => handleChange(e)}>
              {(inc.items && inc.items.BenfName) || 'Select Beneficiary'}
            </button>
            <div id="beneficiary" className={styles.dropdown__droppop + ` ` + `${beneficiary ? styles.show : styles.hide}`}>
              <input type="text" id="mySearch" autoComplete="off" name="beneficiary" onKeyUp={(e) => searchText(e)} style={{ padding: '7px 5px' }} />
              {customerList ? customerList : <h4>No Records Found</h4>}
            </div>
          </div>
          {!beneCheck && !inc.items?.BenfName ? <div className={styles.formgroup__error}>Please select Beneficiary</div> : ''}
        </div>
      )}

      <div className={styles.formGroup} style={location.pathname == '/transfer' ? {} : { margin: '0px 6px 16px 6px' }}>
        <div className={styles.fxFlex + '' + flexStyle}>
          <div className={styles.fxFlex__item + ' ' + widthStyle}>
            <label>You Send</label>
            <div className={styles.currencyConv}>
              <input
                type="text"
                id="sendAmount"
                placeholder="Enter amount"
                name="sendAmount"
                value={sendAmt}
                autoComplete="off"
                onChange={(e) => AmountCalculateLC(e.target)}
                maxLength="13"
              />
              <div>
                <button type="button" onClick={() => lcAmount(!LCAmount)}>
                  {profile?.CurrencyCode1}
                </button>
              </div>
              <img src={kuwaitRoundFlag} alt="" />
            </div>
            <div className={styles.formgroup__error}>{sendAmountErr}</div>
          </div>
          <div className={styles.fxFlex__item + ' ' + widthStyle}>
            <label>they receive</label>
            <div className={styles.currencyConv}>
              {/* <div className={styles.formGroup}> */}
              <input
                type="text"
                id="receiveAmount"
                placeholder="Enter amount"
                autoComplete="off"
                name="receiveAmount"
                value={rcAmt}
                onChange={(e) => AmountCalculateRC(e.target)}
                maxLength="13"
              />
              {/* </div> */}
              <div>
                <button type="button" onClick={() => rcAmount(!RCAmount)}>
                  {rcFlag}
                </button>
              </div>
              <img src={currencyR} />
            </div>
            <div className={styles.formgroup__error}>{receiveAmountErr}</div>
          </div>
        </div>
      </div>
      <div className={styles.btnRight}>
        <button onClick={transButton} className={styles.linkButton}>
          {Label.Transfer.buttonLabel}
        </button>
      </div>
    </div>
  );
}

export { Transfer };
